module.exports = __webpack_public_path__ + "img/logo-ww.2ec774e9.svg";